<template>
    <b-card
        class="dashboard-stat-card h-100"
        :class="{ 'dashboard-stat-card--clickable': to }"
        @click="handleClick"
    >
        <div v-if="loading" class="text-center py-3">
            <b-spinner small type="grow"></b-spinner>
        </div>
        <div v-else>
            <div class="d-flex justify-content-between align-items-start">
                <div>
                    <div v-if="!embedded" class="text-muted text-uppercase small font-weight-bold">{{ title }}</div>
                    <div class="dashboard-stat-card__value">{{ displayValue }}</div>
                    <div v-if="subtitle" class="text-muted small mt-1">{{ subtitle }}</div>
                    <div v-if="changePct !== null && changePct !== undefined" class="small mt-1" :class="changeClass">
                        <i :class="changeIcon"></i>
                        {{ Math.abs(changePct) }}% vs yesterday
                    </div>
                </div>
                <div v-if="icon" class="dashboard-stat-card__icon text-muted">
                    <i :class="icon"></i>
                </div>
            </div>
        </div>
    </b-card>
</template>

<script>
export default {
    name: 'StatCard',
    props: {
        title: { type: String, required: true },
        value: { type: [String, Number], default: null },
        subtitle: { type: String, default: '' },
        icon: { type: String, default: '' },
        format: { type: String, default: 'number' },
        changePct: { type: Number, default: null },
        loading: { type: Boolean, default: false },
        to: { type: [String, Object], default: null },
        embedded: { type: Boolean, default: false },
    },
    computed: {
        displayValue() {
            if (this.value === null || this.value === undefined || this.value === '') {
                return '—'
            }

            if (this.format === 'currency') {
                return '$' + this.numberWithCommas(this.value)
            }

            if (this.format === 'compact-currency') {
                const num = Number(this.value)
                if (num >= 1000000) {
                    return '$' + (num / 1000000).toFixed(1) + 'M'
                }
                if (num >= 1000) {
                    return '$' + (num / 1000).toFixed(1) + 'K'
                }
                return '$' + this.numberWithCommas(num)
            }

            return this.value
        },
        changeClass() {
            if (this.changePct > 0) {
                return 'text-success'
            }
            if (this.changePct < 0) {
                return 'text-danger'
            }
            return 'text-muted'
        },
        changeIcon() {
            if (this.changePct > 0) {
                return 'fas fa-arrow-up'
            }
            if (this.changePct < 0) {
                return 'fas fa-arrow-down'
            }
            return 'fas fa-minus'
        },
    },
    methods: {
        handleClick() {
            if (this.to) {
                this.$router.push(this.to)
            }
        },
    },
}
</script>

<style scoped>
.dashboard-stat-card__value {
    font-size: 1.75rem;
    font-weight: 700;
    line-height: 1.2;
    margin-top: 0.25rem;
}

.dashboard-stat-card__icon {
    font-size: 1.5rem;
    opacity: 0.35;
}

.dashboard-stat-card--clickable {
    cursor: pointer;
    transition: box-shadow 0.15s ease;
}

.dashboard-stat-card--clickable:hover {
    box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.12);
}
</style>
